import React from 'react';

interface FontIconProps {
  color: string;
  size?: number;
}

export const FontIcon: React.FC<FontIconProps> = ({ color, size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7373 18.2383C12.2549 18.2383 11.9565 17.9526 11.9565 17.4893C11.9565 17.3369 11.9819 17.1846 12.0518 17.0005L15.8477 6.86328C16.0571 6.28564 16.4507 6 17.0601 6C17.6948 6 18.0884 6.28564 18.2979 6.86963L22.0874 16.9688C22.1509 17.1592 22.1826 17.3052 22.1826 17.4766C22.1826 17.9399 21.8589 18.2383 21.3701 18.2383C20.9004 18.2383 20.6592 18.0415 20.5005 17.5464L19.4722 14.728H14.6353L13.6069 17.5464C13.4546 18.0415 13.207 18.2383 12.7373 18.2383ZM15.0479 13.4077H19.0723L17.0854 7.84082H17.0347L15.0479 13.4077ZM3.72363 18.2002C3.28564 18.2002 3 17.9399 3 17.521C3 17.3623 3.03174 17.1782 3.10156 17.0068L5.69775 10.126C5.90088 9.56738 6.25 9.30713 6.77051 9.30713C7.31641 9.30713 7.67188 9.57373 7.875 10.126L10.4712 17.0068C10.5347 17.1973 10.5791 17.356 10.5791 17.521C10.5791 17.9272 10.2744 18.2002 9.85547 18.2002C9.46191 18.2002 9.2334 18.0225 9.1001 17.5718L8.41455 15.5977H5.14551L4.45996 17.5654C4.32666 18.0098 4.09814 18.2002 3.72363 18.2002ZM5.50098 14.4741H8.05908L6.84668 10.9067H6.70068L5.50098 14.4741Z"
        fill={color}
      />
    </svg>
  );
};
